import React, { useEffect, useState } from "react";
import { Table, Button } from "react-bootstrap";
import Layout from "../../components/Layout";
import { useNavigate } from "react-router-dom";
import { MdModeEdit, MdDelete } from "react-icons/md";
import ToastFile from "../../utils/ToastFile";
import { deleteTenantByID, getAllTenants } from "../../api/TenantApi";
import { useRef } from "react";

const Tenant = () => {
  const [tenants, setTenants] = useState([]);
  const navigate = useNavigate();
  const fetched = useRef(false);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getTenants();
  }, []);

  const getTenants = () => {
    getAllTenants()
      .then((res) => {
        if (res.status === 200) {
          setTenants(res?.data?.data?.tenants);
        } else {
          ToastFile("Failed to fetch tenants", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching tenants:", err);
        ToastFile("Error fetching tenants", "error");
      });
  };

  const openAddModal = () => {
    navigate("/tenants/add");
  };

  const openEditModal = (index) => {
    const tenant = tenants[index];
    navigate("/tenants/edit", {
      replace: true,
      state: { tenant },
    });
  };

  const deleteTenant = (index) => {
    deleteTenantByID(tenants[index]._id)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("Tenant deleted", "deleted");
          fetched.current = false;
          getTenants();
        } else {
          ToastFile("Failed to delete tenant", "error");
        }
      })
      .catch((err) => {
        console.error("Error deleting tenant:", err);
        ToastFile("Error deleting tenant", "error");
      });
  };

  return (
    <Layout>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
      Tenant Management
          </span>
        <Button onClick={openAddModal} className="bg-dark">
          + Add Tenant
        </Button>
      </div>
      <Table striped bordered hover responsive>
        <thead className="table-dark">
          <tr style={{ textAlign: 'center' }}>
            <th>Name</th>
            <th>Contact No</th>
            <th>Address</th>
            <th>Email</th>
            <th>ABN</th>
            <th>Slug</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tenants.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">
                No tenants found
              </td>
            </tr>
          ) : (
            tenants.map((c, idx) => (
              <tr key={idx}>
                <td>{c.name}</td>
                <td>{c.contact_no}</td>
                <td>{c.address}</td>
                <td>{c.email}</td>
                 <td>{c.abn}</td>
                <td>{c.slug}</td>
                <td>
                  {c.status === "Active" ? (
                    <span className="badge bg-success">{c.status}</span>
                  ) : (
                    <span className="badge bg-danger">{c.status}</span>
                  )}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <span
                    className="me-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => openEditModal(idx)}
                  >
                    <MdModeEdit size={20} />
                  </span>

                  <span
                    className="me-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => deleteTenant(idx)}
                  >
                    <MdDelete size={20} />
                  </span>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </Layout>
  );
};

export default Tenant;
